import { ApiInstance } from '@src/services/api-instance';
import { AutomationsFlowsService } from './flows/automations-api-flows';
import { CanonicalsService } from './canonicals/canonicals-service';
import { RequestsService } from './requests/requests.service';

export class AutomationsV1Service {
  private readonly client: ApiInstance;

  public flows: AutomationsFlowsService;
  public canonicals: CanonicalsService;
  public requests: RequestsService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/v1`, client.getTimeout());

    this.flows = new AutomationsFlowsService(this.client);
    this.canonicals = new CanonicalsService(this.client);
    this.requests = new RequestsService(this.client);
  }
}
